import { render, staticRenderFns } from "./multaxixchart.vue?vue&type=template&id=7906eca6&"
import script from "./multaxixchart.vue?vue&type=script&lang=js&"
export * from "./multaxixchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports